import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-arrow\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M15,6.83,20.17,12,15,17.17V14H5V10H15V6.83M14,3.41a1,1,0,0,0-1,1V8H4A1,1,0,0,0,3,9v6a1,1,0,0,0,1,1h9v3.59a1,1,0,0,0,1,1,1,1,0,0,0,.7-.3l7.58-7.58a1,1,0,0,0,0-1.42L14.71,3.71a1,1,0,0,0-.7-.3Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol